import { useEffect, useState } from 'react';

export const useDeviceDetect = () => {
  const [width, setWidth] = useState<number>(window.innerWidth);
  const [height, setHeight] = useState<number>(window.innerHeight);
  const [isMobile, setIsMobile] = useState<boolean>(false);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  }
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    const userAgent =
      typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
    const isMobileAgent = Boolean(
      userAgent.match(/Android|BlackBerry|iPhone|IEMobile/i)
    );

    setIsMobile(
      width < 768 ||
        (window.matchMedia('(orientation: landscape)').matches &&
          isMobileAgent &&
          width < 896)
    );
  }, [width]);

  return {
    isMobile,
    isTablet: !isMobile && width < 1024,
    currentHeight: height,
    currentWidth: width,
  };
};
